import type { CyberAssessmentTrlBand, TechnologyType } from '@@types/api.types';
import { formatTrlBand } from '@components/pages/technology/components/cyber-score-tile.util';
import { Badge } from '@components/ui/badge';
import { formatDate } from '@utils/date.util';
import React from 'react';

import { formatCyberAssessmentTechnologyTypeLabel } from './technology-cyber-report.util';

type TechnologyCyberReportHeaderProps = {
  completedAt: string;
  technologyTypes: TechnologyType[];
  trlBand: CyberAssessmentTrlBand;
};

const HEADER_BADGE_CLASS_NAME = 'rounded-full px-2.5 py-1 font-medium';

export const TechnologyCyberReportHeader: React.FC<TechnologyCyberReportHeaderProps> = (props) => {
  const { completedAt, technologyTypes, trlBand } = props;

  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-2 text-sm text-gray-500">
      <span>Completed {formatDate(completedAt)}</span>
      <Badge
        className={HEADER_BADGE_CLASS_NAME}
        size="sm"
        variant="outline"
      >
        {formatTrlBand(trlBand)}
      </Badge>
      {technologyTypes.map((technologyType) => (
        <Badge
          className={HEADER_BADGE_CLASS_NAME}
          key={technologyType}
          size="sm"
          variant="outline"
        >
          {formatCyberAssessmentTechnologyTypeLabel(technologyType)}
        </Badge>
      ))}
    </div>
  );
};
